import styled, { css } from 'styled-components'
import { NoMarginRow, NoPaddingCol } from 'Components/EnhacedFlexboxGrid'
import { TitleValueBlockV2 } from 'Layout'

import {
  BREAK_POINT_MD,
} from '@CSSVars/variables'
import {
  LIGHT_BACKGROUND, OUTLINE_COLOR,
} from '@CSSVars/colors'


export const _DetailKeyContainer = styled(NoMarginRow)`
  margin-top: 8px;
`

export const _Col = styled(NoPaddingCol)`
  padding: 14px;
  border-left: none;
  position: relative;
  border-radius: 10px;
  div {
    font-size: 13px;
  }

  ${({ withBg }) => (withBg ? `
    background-color: ${LIGHT_BACKGROUND};
    div {
      color: inherit !important;
    }
    ` : `
    &&:before {
      content: "";
      position: absolute;
      width: 1px;
      height: 98px;
      background-color: ${OUTLINE_COLOR};
      left: 0;
      top: 14px;
    }
    `)}


  @media screen and (max-width: ${BREAK_POINT_MD}) {

    ${({ withBg }) => (withBg ? `
      flex-basis: 100%;
      max-width: 100%;

      &&:after {
        content: "";
        position: absolute;
        width: 4px;
        height: 100%;
        background-color: white;
        left: 50%;
        top: 0;
      }
      ` : '')}
  }
`

export const valueDivClassCss = css`
  font-size: 16px !important;
`

export const _TitleValueBlock = styled(TitleValueBlockV2)`
  margin: -5px 0;
  &:first-child {
    margin-bottom: 21px!important;
  }

  ${({ withBg }) => (withBg ? `
      ` : '')}

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    &:first-child {
      margin-bottom: 17px!important;
    }

    ${({ withBg }) => (withBg ? `
      width: 50%;
      display: inline-block;
      &:first-child {
        margin-bottom: 0!important;
      }
      &:nth-child(2) {
        padding-left: 20px!important;
      }
      ` : '')}
  }
`
